module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "editorElem"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe7eb31e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/components/wangEditor.vue
// module id = 954
// module chunks = 0